/**
 * Translate provider health API message via message_key when present.
 */
export function translateProviderHealthMessage(t, resultOrRow, fallbackMessage) {
  const details = resultOrRow?.details
    || resultOrRow?.health_check?.details
    || {};
  const messageKey = resultOrRow?.message_key
    || details.message_key
    || resultOrRow?.health_check?.message_key;

  if (messageKey) {
    const step = resultOrRow?.message_params?.step
      || details.failed_step
      || resultOrRow?.failed_step;
    return t(`providers:health.messages.${messageKey}`, {
      step: step || '',
      defaultValue: fallbackMessage || resultOrRow?.message || messageKey,
    });
  }

  return fallbackMessage || resultOrRow?.message || '';
}
